<ng-content>
</ng-content>

<div class="tooltip-icon-placeholder"
     [tooltip]="tooltipText || tooltipTemplate"
     [isOpen]="forceOpen"
     [placement]="placement">
</div>
